import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import "./App.css";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { Moon, Sun } from "react-feather";

function App() {
  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem("theme") === "dark";
  });

  useEffect(() => {
    localStorage.setItem("theme", darkMode ? "dark" : "light");
    document.body.className = darkMode ? "dark-mode" : "light-mode";
  }, [darkMode]);

  const toggleTheme = () => {
    setDarkMode((prevMode) => !prevMode);
  };

  return (
    <div className="maintenance-page">
      <div className="toggle-theme">
        <button onClick={toggleTheme}>
          {darkMode ? <Sun size={30} color="white" /> : <Moon size={30} />}
        </button>
      </div>
      <div className="animation">
        <DotLottieReact
          src="https://lottie.host/4b864e8c-24c5-48e4-a771-7c52a44e6dd8/Fo0ywZlvjp.lottie"
          loop
          autoplay
        />
      </div>
      <div className="content">
        <h1>🚧 UNDER MAINTENANCE 🚧</h1>
        <p>
          Kami sedang meningkatkan layanan kami untuk meningkatkan layanan yang
          lebih baik.
        </p>
        <p>Terima kasih atas kunjungan Anda!</p>
      </div>
      <footer>
        <p>&copy; 2025 Mitra Properti. All Rights Reserved.</p>
      </footer>
    </div>
  );
}

export default App;
